import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import MenuItem from '@material-ui/core/MenuItem'
import { injectIntl } from 'react-intl'
import Button from '@material-ui/core/Button'
import { Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { Checkbox, Select } from 'components/common/FormInputs'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_LATITUDE,
  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
  VALIDATOR_IS_LONGITUDE,
} from 'validation'
import Input from 'components/common/Form/Input'
import RoleHelper from 'helpers/role'
import 'moment-timezone'
import TimeZone from 'components/common/Form/TimeZone'
import messages from './translate'

class SiteForm extends Component {
  getFormData = site => {
    let formData = {
      siteGroups: [],
    }

    if (site) {
      const {
        name,
        siep,
        active,
        visibleInUi,
        cmCode,
        timezone,
        type,
        siteGroups,
        location,
      } = site

      formData = {
        name,
        siep,
        active,
        visibleInUi,
        cmCode,
        timezone,
        siteType: type ? type.id : null,
        siteGroups: siteGroups.map(group => group.id),
        latitude: location ? location.latitude : null,
        longitude: location ? location.longitude : null,
      }
    }

    return formData
  }

  render() {
    const {
      formData: { siteTypes, siteGroups, site },
      onSubmit,
      roleLevel,
      intl: { formatMessage },
    } = this.props
    const initialValues = this.getFormData(site)

    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, submitting, pristine }) => (
          <form onSubmit={handleSubmit} className="form-basic">
            <div className="form-group">
              <Field
                name="name"
                type="text"
                label={formatMessage(messages.name)}
                component={Input}
                disabled={submitting}
                required
                validate={getValidator([
                  VALIDATOR_IS_EMPTY,
                  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
                ])}
              />
              <div className="form-group">
                <Field
                  name="siteType"
                  component={Select}
                  label={formatMessage(messages.siteType)}
                  disabled={submitting}
                  formControlProps={{
                    fullWidth: true,
                    required: true,
                  }}>
                  {siteTypes.map((siteType, index) => (
                    <MenuItem
                      key={`${siteType.id}_${index}`}
                      component="li"
                      button
                      value={siteType.id}>
                      {siteType.type}
                    </MenuItem>
                  ))}
                </Field>
              </div>
              <Field
                name="siep"
                type="text"
                label={formatMessage(messages.siep)}
                component={Input}
                disabled={submitting}
              />
              <div className="form-group">
                <Field
                  multiple
                  name="siteGroups"
                  component={Select}
                  label={formatMessage(messages.siteGroups)}
                  disabled={submitting}
                  formControlProps={{
                    fullWidth: true,
                  }}>
                  {siteGroups.map((group, index) => (
                    <MenuItem
                      key={`${group.id}_${index}`}
                      component="li"
                      button
                      value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Field>
              </div>
              <Field
                name="cmCode"
                type="text"
                label={formatMessage(messages.cmCode)}
                component={Input}
                disabled={submitting}
              />
              {roleLevel >= RoleHelper.ROLE_SUPERADMIN_LEVEL && (
                <TimeZone submitting={submitting} />
              )}
              <FormControl fullWidth component="div" className="form-group">
                <FormControlLabel
                  label={formatMessage(messages.active)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="active"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
                <FormControlLabel
                  label={formatMessage(messages.visible)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="visibleInUi"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
              </FormControl>
            </div>
            <Typography variant="h6" color="textSecondary" className="headline">
              {formatMessage(messages.locationInfo)}
            </Typography>
            <div className="form-group">
              <Field
                name="latitude"
                type="text"
                label={formatMessage(messages.latitude)}
                component={Input}
                disabled={submitting}
                validate={getValidator([VALIDATOR_IS_LATITUDE])}
              />
              <Field
                name="longitude"
                type="text"
                label={formatMessage(messages.longitude)}
                component={Input}
                disabled={submitting}
                validate={getValidator([VALIDATOR_IS_LONGITUDE])}
              />
            </div>
            <div className="form-group buttons">
              <Button
                href={null}
                type="submit"
                color="primary"
                size="medium"
                variant="contained"
                onClick={handleSubmit}
                disabled={submitting || pristine}>
                {formatMessage(messages.saveInfo)}
              </Button>
            </div>
          </form>
        )}
      />
    )
  }
}

export default connect(state => ({
  roleLevel: state.getIn(['profile', 'roleLevel']),
}))(injectIntl(SiteForm))
